import { APIURL } from '../services/axiosServices/ApiEndPoints';
import { decryptionAPI } from './Encryption';
import { generateRequestSignature } from './RequestSigning';

const axios = require('axios');

export const axiosInstance = axios.create({
    baseURL: APIURL
})

axiosInstance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
)

const isHandlerEnabled = (config = {}) => {
    return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ?
        false : true
}

const requestHandler = (request) => {
    if (isHandlerEnabled(request)) { }

    // ── SIGN EVERY REQUEST ────────────────────────────────────
    const url = new URL(request.url);
    const endpoint = url.pathname + url.search;

    const { timestamp, nonce, signature } = generateRequestSignature(endpoint);
    request.headers['X-Timestamp'] = timestamp;
    request.headers['X-Nonce'] = nonce;
    request.headers['X-Signature'] = signature;
    // ─────────────────────────────────────────────────────────

    return request;
}

axiosInstance.interceptors.request.use(
    request => requestHandler(request)
)

const errorHandler = (error) => {
    if (isHandlerEnabled(error.config)) { }
    return Promise.reject({ ...error })
}

const successHandler = (response) => {
    if (isHandlerEnabled(response.config)) {
        response = decryptionAPI(response.data);
    }
    return response
}

// ── ADD INTERCEPTOR TO SECOND INSTANCE TOO ───────────────────
export const axiosInstanceWithoutEnrypt = axios.create({
    baseURL: APIURL
})

axiosInstanceWithoutEnrypt.interceptors.request.use((request) => {
    const url = new URL(request.url);
    const endpoint = url.pathname + url.search;
    const { timestamp, nonce, signature } = generateRequestSignature(endpoint);

    request.headers['X-Timestamp'] = timestamp;
    request.headers['X-Nonce'] = nonce;
    request.headers['X-Signature'] = signature;

    return request;
});
// ─────────────────────────────────────────────────────────────